import { render } from "./PunchIn.vue?vue&type=template&id=79b83b26"
import script from "./PunchIn.vue?vue&type=script&lang=js"
export * from "./PunchIn.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__